import React from 'react';
import MessagingIcon from '@tradera/blueprint/theme/icons/mail.svg?jsx';
import triot from 'triot';

const handleButtonClick = emailPayload => {
    triot.bus.trigger('ui:contact-modal:show-modal', emailPayload);
};

const MessagingButtonEmail = ({
    label,
    className,
    emailPayload,
    isLoggedIn,
    handleLogin
}) => {
    return (
        <button
            className={`btn btn-outline-primary ${className}`}
            onClick={
                !isLoggedIn
                    ? handleLogin
                    : () => handleButtonClick(emailPayload)
            }>
            <MessagingIcon
                className="icon icon-before"
                style={{ verticalAlign: 'text-bottom' }}
            />
            <span className="default-label">{label}</span>
        </button>
    );
};

export default MessagingButtonEmail;
